module.exports = __webpack_public_path__ + "static/media/Fanollywood_New_Logo.88cef0a9.png";